import React from 'react';
import FormGroup from '@material-ui/core/FormGroup';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import Switch from '@material-ui/core/Switch';
import {useDispatch, useSelector} from "react-redux";
import {RootState} from "../../../Store/Reducers";
import {FilterActions} from "../../../Store/Filter/Slice";
import {PickupActions} from "../../../Store/Pickup/Slice";

export default function SwitchComponent() {

  const dispatch = useDispatch();

  const {FilterReducer: {dashboardFilters}} = useSelector((state: RootState) => state);

  const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => {
    dispatch(FilterActions.setDashboardFilters({ ...dashboardFilters, [event.target.name]: event.target.checked }));
    dispatch(PickupActions.getPickups());
  };

  return (
    <FormGroup row>
      <FormControlLabel
        control={<Switch checked={dashboardFilters.shippingPending}
                         onChange={handleChange}
                         color="default"
                         className={dashboardFilters.shippingPending ? "red-thumb-active" : "red-thumb"}
                         name="shippingPending" />}
        label="Pendiente"
      />

      <FormControlLabel
        control={
          <Switch
            checked={dashboardFilters.shippingSchedule}
            onChange={handleChange}
            name="shippingSchedule"
            color="default"
            className={dashboardFilters.shippingSchedule ?"green-thumb-active" :"green-thumb"}
          />
        }
        label="Agendada"
      />

      <FormControlLabel
        control={<Switch checked={dashboardFilters.shippingPickup}
                         onChange={handleChange}
                         color="default"
                         className={dashboardFilters.shippingPickup ? "blue-thumb-active" : "blue-thumb"}
                         name="shippingPickup" />}
        label="Recogida"
      />

      <FormControlLabel
        control={<Switch checked={dashboardFilters.shipmentInTransit}
                         onChange={handleChange}
                         color="default"
                         className={dashboardFilters.shipmentInTransit ? "yellow-thumb-active" : "yellow-thumb"}
                         name="shipmentInTransit" />}
        label="Transito"
      />
    </FormGroup>
  );
}
